import * as url from './Url';
export const API_URL = url.API_URL;

export const MODE_GENERATE_TOKEN    = "generateToken";
export const MODE_LOGIN             = "login";
export const MODE_LOGOUT            = "logout";
export const GET_LEAD_MODE          = "getLeads"; 
export const CHANGE_LEAD_STATUS     = "changeLeadStatus";
export const GET_LEAD_DETAILS_MODE  = "leadDetails";
export const GET_APP_FORM_DATA_MODE = "applicationFormDetails";
export const GET_DASHBOARD_DATA     = "dashboard";
export const GET_COMMENTS_MODE      = "getLeadComments";
export const CREATE_LEAD            = "createLead";
export const UPDATE_LEAD            = "updateLead";
export const CREATE_LOAN            = "createLoan";
export const ADD_COMMENT            = "addComment";
export const SEND_PERFIOS_MODE      = "sendPerfiosLink";
export const SEND_DOCLINK_MODE      = "sendDocLink";
export const SEND_OTP               = "sendOtp";
export const SUBMIT_OTP             = "submitOtp";
export const COMPANIES              = "getCompanies";
export const RECHECK_APPROVAL_STATUS        = "recheckApprovalStatus";
export const SEND_EMAIL_VERIFICATION_MODE   = "sendEmailVerificationLink";
export const SEND_MOBILE_VERIFICATION_MODE  = "sendMobileVerificationLink";
export const SEND_CIBIL_VERIFICATION_MODE   = "sendForCibil";
export const ADD_DOCUMENT                   = "uploadDocument";
export const ALLOWBANKSTATEMENT             = "allowBankStatementUpload";
export const GET_DSA_REPORTS                = "dsaReport";
export const GET_CARD_DETAILS               = "cardRegistered";
export const CARD_NOT_REGISTER              = "changeCardStatus";
export const GET_FOS_SHEET_DETAILS          = "fosSheetDetails";
export const SUBMIT_FOS_SHEET               = "saveFosSheet";
export const CREDIT_PENDENCY                = "saveComment";
export const ASSIGN_LEADS                   = "assignLeads";
export const SUBMIT_OFFICE_DETAIL_MODE      = "updateOfficeAddress";
export const VERIFY_TOKEN_MODE              = "validateOauthToken";
export const GET_PRODUCTS_MODE              = "getProducts";
export const GET_AMORTIZATION_SCHEDULE      = "getAmortizationSchedule";
export const GET_CUSTOMER_AMORTIZATION_SCHEDULE = "saveamortization";
export const IS_LOGGED_IN                       = "is_logged_in";
export const AUTH_TOKEN                         = "auth_token";
export const TOKEN                              = "token";
export const ORG_ID                             = "org_id";
export const HIGHEST_EDUCATION                  = "highest_education";
export const SAVE_AMORTIZATION                  = "saveAndApproveAmort";
export const GET_SAVED_CUSTOMER_AMORT_SCHEDULE  = "getAmort";
export const GET_DSA_BANK_DETAILS               = "getBankDetails";
export const GET_CITY_LIST                      = "getCity";
export const CREATE_DSA_DETAILS                 = "createDsa";
export const INV_ACC                            = "invoice_access";
export const DSA_REPORT_HEADING                 = "dsa_report";
export const GENERATE_INVOICE                   = "generateInvoice";
export const ADD_SLAB                           = "addSlab";
export const GET_DSA_INFO                       = "getDsaInfo";
export const GET_DSA_ORGANIZATIONS              = "getOrganizations";
export const CONFIRM_INVOICE_GENERATE           = "confirmInvoiceGenerate";
export const GET_DSA_DETAILS                    = "getDsaDetail";
export const GET_DSA_SLABS                      = "getSlabs";
export const GET_REFERENCE_STATES               = "getAllState";
export const GET_REFERENCE_CITIES               = "getAllCity";
export const GET_FRIEND_REFERENCE_DETAILS       = "getReferences";
export const SET_REFERENCE_DETAILS              = "saveReference";
export const GET_PERMANENT_ADDRESS_DETAILS      = "getPermanentAddress";
export const SET_PERMANENT_ADDRESS_DETAILS      = "savePermanentAddress";
export const SEND_INVOICE_PDF                   = "sendInvoicePdf";
export const SEND_PDF_MODE                      = "sendCFAFform";
export const DISBURSAL_REPORTING                = "disbursalReporting";
export const POS_REPORTING                      = "posData";
export const PAYMENT_HIS_DETAILS                = "paymentHistoryDetails";
export const AKARA_POS_DATA                     = "AkaraPosData";
export const INST_DETAILS                       = "instDetails";
export const DETAILS_PAGE                       = "detailsPage";
export const AKARA_DETAILS_PAGE                 = "AkaraDetailsPage";
export const INST_COLENDER                      = "instColender";
export const APPLICANT_DETAILS                  = "applicantDetails";
export const AMOUNT_COUNT                       = "getAmountCount";
export const POS_BIFURCATION                    = "getPosBifurcation";
export const POS_paymentHistory_Details         = "POSpaymentHistoryDetails";





// WEBPACK FOOTER //
// ./src/constants/AppConstants.js